import { render, staticRenderFns } from "./numero.vue?vue&type=template&id=f180c454&scoped=true&"
import script from "./numero.vue?vue&type=script&lang=js&"
export * from "./numero.vue?vue&type=script&lang=js&"
import style0 from "./numero.vue?vue&type=style&index=0&id=f180c454&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f180c454",
  null
  
)

export default component.exports